import Joi from "joi-browser";

function requiredErrorsAsString(errors) {
    let stringError = "";
    let err = errors[0];
    if (err.type === "any.empty") {
        stringError = "can't be an empty field.";
    } else {
        stringError = "is required";
    }

    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: stringError,
        },
    };
}

const ScansSchema = Joi.object().keys({
    sampleName: Joi.string()
        .trim()
        .max(256)
        .min(3)
        .alphanum()
        .required()
        .label("Sample Name")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "string.max":
                        return `can't exceed ${err.context.limit} letters.`;
                    case "string.min":
                        return `can't be less than ${err.context.limit} letters.`;
                    case "any.empty":
                        return "can't be an empty field.";
                    case "string.alphanum":
                        return "should be an alphabetical characters only.";
                    default:
                        return "is required";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    createdById: Joi.string()
        .label("On Behalf Of")
        .error((errors) => {
            requiredErrorsAsString(errors);
        }),
    capturedAt: Joi.date()
        .required()
        .label("Captured At")
        .error((errors) => {
            requiredErrorsAsString(errors);
        }),

    model: Joi.required()
        .label("Model")
        .error((errors) => {
            requiredErrorsAsString(errors);
        }),
});

const ScansPrerequisitesSchema = Joi.object().keys({
    material: Joi.object().required(),
});

const ScanFilterNameSchema = Joi.object().keys({
    filterName: Joi.string()
        .required()
        .label("Filter Name")
        .error((errors) => {
            return requiredErrorsAsString(errors);
        }),
});

export default { ScansSchema, ScansPrerequisitesSchema, ScanFilterNameSchema };
